import { render, staticRenderFns } from "./DevicesListItem.vue?vue&type=template&id=10c4e0ff&scoped=true&"
import script from "./DevicesListItem.vue?vue&type=script&lang=ts&"
export * from "./DevicesListItem.vue?vue&type=script&lang=ts&"
import style0 from "./DevicesListItem.vue?vue&type=style&index=0&id=10c4e0ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c4e0ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
